import { FullPageError } from "@/components/FullPageError";
import { Component, type ErrorInfo, type ReactNode } from "react";
import { WebAppErr } from "./WebAppErr";
import { handleErrors } from "./handleErrors";

interface ErrorBoundaryStateType {
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<
  { children: ReactNode },
  ErrorBoundaryStateType
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // Catch errors in any components below and re-render with error message
    this.setState({
      errorInfo,
    });

    const webAppErr = new WebAppErr(error.message);

    handleErrors(webAppErr);
  }

  render() {
    const { errorInfo } = this.state;
    const { children } = this.props;
    if (errorInfo) {
      return <FullPageError />;
    }

    return children;
  }
}

export { ErrorBoundary };
